import styled from 'styled-components';
import { colors, toRgba } from '@/styles';

export const FileVersionSelect = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
